// =============================================================================
// The card builder's highlight (special-card config): which of the builder's
// markers are on screen in this preview door. The builder shows a hidden copy of
// its till phone for the card being edited, with a short marker in each of its
// boxes; the copy answers with the markers it's showing, so the builder can light
// up exactly the boxes whose words are on the till right now.
//
// A marker counts when it's in a text node that isn't hidden (display, visibility
// or opacity up the chain) or covered by something else where it sits in view, or
// in the placeholder of a visible empty box. Only the builder's own strings are
// looked for, and only those are sent back: nothing on the page is.
// =============================================================================

export function previewVisibleMarkers(markers) {
  const doc = document;
  const hiddenUp = (el) => {
    for (let e = el; e && e.nodeType === 1; e = e.parentElement) {
      const cs = getComputedStyle(e);
      if (cs.display === "none" || cs.visibility === "hidden" || Number(cs.opacity) === 0) return true;
    }
    return false;
  };
  const covered = (el, rect) => {
    const x = rect.left + Math.min(rect.width / 2, 6), y = rect.top + rect.height / 2;
    if (x < 0 || y < 0 || x >= window.innerWidth || y >= window.innerHeight) return false;
    const top = doc.elementFromPoint(x, y);
    return !!top && !(top === el || el.contains(top) || top.contains(el));
  };
  const found = new Set();
  const wanted = markers.map((m) => [m, m.toLowerCase()]);
  const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
  for (let n = walker.nextNode(); n; n = walker.nextNode()) {
    const txt = String(n.nodeValue || "").toLowerCase();
    for (const [m, low] of wanted) {
      if (found.has(m)) continue;
      const i = txt.indexOf(low);
      if (i === -1) continue;
      const el = n.parentElement;
      if (!el || hiddenUp(el)) continue;
      const r = doc.createRange();
      r.setStart(n, i);
      r.setEnd(n, i + low.length);
      const rect = r.getBoundingClientRect();
      if (!rect.width || !rect.height || covered(el, rect)) continue;
      found.add(m);
    }
  }
  doc.querySelectorAll("input[placeholder], textarea[placeholder]").forEach((inp) => {
    const ph = String(inp.getAttribute("placeholder") || "").toLowerCase();
    if (inp.value || hiddenUp(inp)) return;
    for (const [m, low] of wanted) if (ph.indexOf(low) !== -1) found.add(m);
  });
  return markers.filter((m) => found.has(m));
}

// Resolves once the page has had no DOM changes for quietMs (or after maxMs).
export function previewPageQuiet(quietMs, maxMs) {
  return new Promise((resolve) => {
    let t = null;
    let cap = null;
    const obs = new MutationObserver(() => { if (t) clearTimeout(t); t = setTimeout(done, quietMs); });
    function done() { if (t) clearTimeout(t); obs.disconnect(); clearTimeout(cap); resolve(); }
    obs.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true });
    t = setTimeout(done, quietMs);
    cap = setTimeout(done, maxMs);
  });
}
